import React, { useEffect, useCallback, useState} from 'react';
import {connect} from 'react-redux';

const WIDTH = 30;
const HEIGHT = 15;

const ModulatorNode = ({modulator, i, width, height, lineDragging, setLineDragging, el}) => { 
    let x = 2 + i * (WIDTH + 3);
    let y= height - HEIGHT;

    const onMouseDown = useCallback((e) => {
        let rect = el.current.getBoundingClientRect();
        let x = e.clientX - rect.left;
        let y = e.clientY - rect.top;
        
        setLineDragging({x1: x, y1: y, x2: x, y2: y, modulator});
    }, [setLineDragging, el]);

    const onMouseUp = useCallback((e) => {
        if (lineDragging) {
            let {parameter} = lineDragging;
            if (!parameter.isAudioParamEnabled()) {
                parameter.enableAudioParam();
            }

            if (modulator.getType() === "LFO") {
                parameter.connectToLFO(modulator);
            } else {
                parameter.connectToEnvelope(modulator);
            }
        }
    }, [lineDragging, setLineDragging, modulator]);

    return (
        <g>
          <circle
            onMouseUp={onMouseUp}
            onMouseDown={onMouseDown}
            cx={x+14}
            cy={y-3}
            r={3}
          />
          <rect
            x={x}
            y={y}
            width={WIDTH}
            height={HEIGHT}
            fill={"gray"}
          />
          <text x={x+2} y={y + 14}>
            {modulator.name}
          </text>
        </g>
    );
}

const mapStateToProps = (state, props) => {
  return {
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(ModulatorNode);
